/* KIS productpagina: kijkersteller, mobiele puntjes + pijlen in de galerij, aftelklok, social proof,
   sticky winkelwagenbalk, Klarna-regel, maatadvies-popup en de "complete the set"-status.
   Werkt samen met Dawn's product-info.js / product-form.js / media-gallery.js (pubsub: variantChange). */
(function () {
  'use strict';

  const onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  const subscribeVariantChange = (cb) => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return () => {};
    return subscribe(PUB_SUB_EVENTS.variantChange, cb);
  };

  /* ---------- Kijkersteller ("Door N aantal mensen bekeken in 24h"): willekeurig getal, zoals live ---------- */
  if (!customElements.get('kis-viewers')) {
    customElements.define(
      'kis-viewers',
      class KisViewers extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10) || 50;
          const max = parseInt(this.dataset.max, 10) || 200;
          const count = this.querySelector('[data-kis-viewers-count]');
          const spinner = this.querySelector('[data-kis-viewers-spinner]');
          if (!count) return;
          window.setTimeout(() => {
            count.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
            if (spinner) spinner.classList.add('hidden');
            count.classList.remove('hidden');
            this.classList.add('is-visible');
          }, 800);
        }
      }
    );
  }

  /* ---------- Galerij: puntjes (mobiel) en pijlen (desktop) ---------- */
  if (!customElements.get('kis-gallery-nav')) {
    customElements.define(
      'kis-gallery-nav',
      class KisGalleryNav extends HTMLElement {
        connectedCallback() {
          this.gallery = this.closest('media-gallery');
          if (!this.gallery) return;
          this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
          this.list = this.gallery.querySelector('[id^="Slider-Gallery"]');
          this.dots = this.gallery.querySelector('[data-kis-dots]');
          if (!this.viewer || !this.list) return;

          this.buildDots();
          this.viewer.addEventListener('slideChanged', (e) => this.onSlideChanged(e));
          this.list.addEventListener('scroll', () => this.syncDotsFromScroll(), { passive: true });

          this.querySelectorAll('[data-kis-arrow]').forEach((btn) => {
            btn.addEventListener('click', () => this.step(btn.dataset.kisArrow === 'next' ? 1 : -1));
          });

          this.observer = new MutationObserver(() => this.syncDotsFromActive());
          this.observer.observe(this.list, { attributes: true, subtree: true, attributeFilter: ['class'] });
        }

        get items() {
          return Array.from(this.list.querySelectorAll('li[data-media-id]'));
        }

        buildDots() {
          if (!this.dots) return;
          this.dots.innerHTML = '';
          const items = this.items;
          if (items.length < 2) return;
          items.forEach((item, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'kis-gallery__dot' + (i === 0 ? ' kis-gallery__dot--active' : '');
            b.setAttribute('aria-label', 'Foto ' + (i + 1));
            b.addEventListener('click', () => {
              this.list.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
            });
            this.dots.appendChild(b);
          });
        }

        setActiveDot(index) {
          if (!this.dots) return;
          this.dots.querySelectorAll('.kis-gallery__dot').forEach((d, i) => {
            d.classList.toggle('kis-gallery__dot--active', i === index);
          });
        }

        onSlideChanged(e) {
          const el = e.detail && e.detail.currentElement;
          if (!el) return;
          this.setActiveDot(this.items.indexOf(el));
        }

        syncDotsFromScroll() {
          const items = this.items;
          if (!items.length) return;
          const w = items[0].offsetWidth || 1;
          const idx = Math.round(this.list.scrollLeft / w);
          this.setActiveDot(Math.max(0, Math.min(idx, items.length - 1)));
        }

        syncDotsFromActive() {
          const items = this.items;
          const idx = items.findIndex((i) => i.classList.contains('is-active'));
          if (idx >= 0 && window.matchMedia('(min-width: 750px)').matches) this.setActiveDot(idx);
        }

        step(dir) {
          const items = this.items;
          if (items.length < 2) return;
          let idx = items.findIndex((i) => i.classList.contains('is-active'));
          if (idx < 0) idx = 0;
          const next = (idx + dir + items.length) % items.length;
          const id = items[next].dataset.mediaId;
          if (typeof this.gallery.setActiveMedia === 'function') this.gallery.setActiveMedia(id, false);
        }
      }
    );
  }

  /* ---------- Aftelklok (logica van live countdown-timer-2: 9u/21u-cyclus of vaste starturen) ---------- */
  if (!customElements.get('kis-pdp-countdown')) {
    customElements.define(
      'kis-pdp-countdown',
      class KisCountdown extends HTMLElement {
        connectedCallback() {
          this.useScheduled = this.dataset.useScheduledTimer === 'true';
          const startHour = parseInt(this.dataset.startHour, 10);
          this.startHour = isNaN(startHour) ? 9 : startHour;
          this.endHour = (this.startHour + 12) % 24;

          const serverNow = this.dataset.serverNow ? new Date(this.dataset.serverNow.replace(' ', 'T')) : new Date();
          this.timeOffset = isNaN(serverNow.getTime()) ? 0 : serverNow.getTime() - Date.now();

          this.els = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]'),
          };
          if (!this.els.days || !this.els.hours || !this.els.minutes || !this.els.seconds) return;

          this.endTime = this.computeEndTime(new Date(Date.now() + this.timeOffset));
          this.update();
          this.interval = window.setInterval(() => this.update(), 1000);
        }

        disconnectedCallback() {
          if (this.interval) window.clearInterval(this.interval);
        }

        computeEndTime(now) {
          const h = now.getHours();
          const end = new Date(now);
          const start = this.useScheduled ? this.startHour : 9;
          const stop = this.useScheduled ? this.endHour : 21;
          if (h >= start && h < stop) {
            end.setHours(stop, 0, 0, 0);
          } else {
            if (h >= stop) end.setDate(end.getDate() + 1);
            end.setHours(start, 0, 0, 0);
          }
          return end.getTime();
        }

        update() {
          const now = Date.now() + this.timeOffset;
          let distance = this.endTime - now;
          if (distance < 0) {
            this.endTime = this.computeEndTime(new Date(now));
            distance = this.endTime - now;
          }
          const days = Math.floor(distance / 86400000);
          const hours = Math.floor((distance % 86400000) / 3600000);
          const minutes = Math.floor((distance % 3600000) / 60000);
          const seconds = Math.floor((distance % 60000) / 1000);
          this.setDigits(this.els.days, days);
          this.setDigits(this.els.hours, hours);
          this.setDigits(this.els.minutes, minutes);
          this.setDigits(this.els.seconds, seconds);
        }

        setDigits(el, value) {
          const digits = String(value).padStart(2, '0').split('');
          const spans = el.querySelectorAll('.kis-timer__digit');
          digits.forEach((d, i) => {
            if (spans[i] && spans[i].textContent !== d) spans[i].textContent = d;
          });
        }
      }
    );
  }

  /* ---------- Social proof: snelheid afhankelijk van het aantal avatars (zoals live) ---------- */
  if (!customElements.get('kis-social-proof')) {
    customElements.define(
      'kis-social-proof',
      class KisSocialProof extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('.kis-social__track');
          if (!track) return;
          const duration = Math.max(track.children.length * 2, 20);
          track.style.animationDuration = duration + 's';
        }
      }
    );
  }

  /* ---------- Klarna-regel: prijs / 3 bijwerken bij variantwissel ---------- */
  if (!customElements.get('kis-klarna')) {
    customElements.define(
      'kis-klarna',
      class KisKlarna extends HTMLElement {
        connectedCallback() {
          this.priceEl = this.querySelector('[data-kis-klarna-price]');
          this.unsubscribe = subscribeVariantChange(({ data }) => {
            const v = data && data.variant;
            if (!v || !this.priceEl || typeof v.price !== 'number') return;
            const amount = (v.price / 100 / 3).toFixed(2).replace('.', ',');
            this.priceEl.textContent = (this.dataset.symbol || '€') + amount;
          });
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }
      }
    );
  }

  /* ---------- Sticky winkelwagenbalk ---------- */
  if (!customElements.get('kis-sticky-cart')) {
    customElements.define(
      'kis-sticky-cart',
      class KisStickyCart extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.button = this.querySelector('[data-kis-sticky-submit]');
          this.variantEl = this.querySelector('[data-kis-sticky-variant]');
          this.priceEls = this.querySelectorAll('[data-kis-sticky-price]');
          this.mainButton = document.getElementById('ProductSubmitButton-' + this.sectionId);
          this.mainForm = document.getElementById('product-form-' + this.sectionId);
          if (!this.mainButton && !this.mainForm) return;

          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();

          if (this.button) {
            this.button.addEventListener('click', (e) => {
              e.preventDefault();
              const btn = document.getElementById('ProductSubmitButton-' + this.sectionId);
              if (btn && !btn.disabled) btn.click();
            });
          }

          this.unsubscribe = subscribeVariantChange(({ data }) => this.onVariantChange(data));
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          if (this.unsubscribe) this.unsubscribe();
          this.setVisible(false);
        }

        onScroll() {
          // Zoals de oude site (Luc 14 okt): de balk verschijnt pas als je voorbij de koopknop scrolt en verdwijnt weer zodra die in beeld is.
          // Mobiel: koopknop boven het scherm uit; desktop: formulier boven het scherm uit.
          if (window.matchMedia('(max-width: 989px)').matches) {
            const btn = this.mainButton || this.mainForm;
            this.setVisible(btn.getBoundingClientRect().bottom <= 0);
            return;
          }
          const anchor = this.mainForm || this.mainButton;
          const rect = anchor.getBoundingClientRect();
          this.setVisible(rect.top < 0);
        }

        /* Zichtbaarheid: klasse op de balk + op <body> (kis-sticky-cart-visible) + event kis:sticky-cart,
           zodat andere lagen (mobiele pill-navigatie) zich kunnen terugtrekken. */
        setVisible(visible) {
          if (this.visible === visible) return;
          this.visible = visible;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', visible ? 'false' : 'true');
          document.body.classList.toggle('kis-sticky-cart-visible', visible);
          document.dispatchEvent(new CustomEvent('kis:sticky-cart', { detail: { visible } }));
        }

        onVariantChange(data) {
          if (!data || data.sectionId !== this.sectionId) return;
          const v = data.variant;
          if (!v) return;
          if (this.variantEl && v.title && v.title !== 'Default Title') this.variantEl.textContent = v.title;
          const priceNode = document.querySelector('#price-' + this.sectionId + ' .kis-pprice__sale, #price-' + this.sectionId + ' .kis-pprice__regular');
          if (priceNode) this.priceEls.forEach((el) => (el.textContent = priceNode.textContent.trim()));
          if (this.button) this.button.toggleAttribute('disabled', !v.available);
        }
      }
    );
  }

  /* ---------- Maatadvies-popup ---------- */
  if (!customElements.get('kis-size-guide')) {
    customElements.define(
      'kis-size-guide',
      class KisSizeGuide extends HTMLElement {
        connectedCallback() {
          this.popup = this.querySelector('.kis-sizeguide');
          if (!this.popup) return;
          document.querySelectorAll('[data-kis-open-sizeguide="' + this.id + '"]').forEach((btn) => {
            btn.addEventListener('click', () => this.open());
          });
          this.querySelectorAll('[data-kis-close-sizeguide]').forEach((btn) => btn.addEventListener('click', () => this.close()));
          this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup) this.close();
          });
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.popup.classList.contains('is-open')) this.close();
          });
        }

        open() {
          this.popup.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }

        close() {
          this.popup.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    );
  }

  /* ---------- 24H-uitleg (Luc 21 okt): pop-up achter de 24H-chip bij de maatkiezer, zelfde mechaniek als de maatadvies-popup ---------- */
  if (!customElements.get('kis-24h-info')) {
    customElements.define(
      'kis-24h-info',
      class Kis24hInfo extends HTMLElement {
        connectedCallback() {
          this.popup = this.querySelector('.kis-24h');
          if (!this.popup) return;
          // gedelegeerd: de chip zit in <variant-selects>, dat Dawn's product-info bij een variantwissel opnieuw rendert
          // capture-fase op window: op telefoon onderschept een ander script de klik vóór document (preventDefault), dus hier als eerste
          if (!this.delegated) {
            this.delegated = true;
            window.addEventListener('click', (e) => {
              const btn = e.target.closest && e.target.closest('[data-kis-open-24h]');
              if (!btn || btn.getAttribute('data-kis-open-24h') !== this.id) return;
              e.preventDefault(); e.stopPropagation(); this.opener = btn; this.open();
            }, true);
          }
          this.querySelectorAll('[data-kis-close-24h]').forEach((btn) => btn.addEventListener('click', () => this.close()));
          this.popup.addEventListener('click', (e) => { if (e.target === this.popup) this.close(); });
          document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.popup.classList.contains('is-open')) this.close(); });
        }
        open() {
          this.popup.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          const card = this.popup.querySelector('.kis-24h__card'); if (card) card.scrollTop = 0;
          const x = this.popup.querySelector('.kis-24h__x') || this.popup.querySelector('.kis-24h__close');
          if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
          if (card) card.scrollTop = 0;
        }
        close() {
          this.popup.classList.remove('is-open');
          document.body.style.overflow = '';
          if (this.opener) this.opener.focus();
        }
      }
    );
  }

  /* ---------- Knoptekst "Toevoegen aan winkelwagen" (blokinstelling) ook na variantwissel (product-form.js
     zet window.variantStrings.addToCart terug) ---------- */
  onReady(() => {
    const el = document.querySelector('[data-kis-atc-text]');
    if (el && el.dataset.kisAtcText && window.variantStrings) window.variantStrings.addToCart = el.dataset.kisAtcText;
  });

  /* ---------- Recent bekeken: producthandle vooraan in localStorage "kis:recent" (JSON-array, nieuwste eerst,
     ontdubbeld, max 20); de winkelwagenpagina leest deze lijst (contract agent D) ---------- */
  onReady(() => {
    const info = document.querySelector('product-info[data-product-handle]');
    const handle = info && info.dataset.productHandle;
    if (!handle) return;
    try {
      let list = JSON.parse(window.localStorage.getItem('kis:recent') || '[]');
      if (!Array.isArray(list)) list = [];
      list = [handle].concat(list.filter((h) => h !== handle)).slice(0, 20);
      window.localStorage.setItem('kis:recent', JSON.stringify(list));
    } catch (e) {
      /* localStorage niet beschikbaar (privémodus): stil overslaan */
    }
  });

  /* ---------- "Complete the set": kaart krijgt is-complete zodra er een maat gekozen is ---------- */
  onReady(() => {
    const update = (picker) => {
      picker.querySelectorAll('.kis-vp__option').forEach((opt) => {
        opt.classList.toggle('is-complete', !!opt.querySelector('input[type="radio"]:checked'));
      });
    };
    const init = () => document.querySelectorAll('.kis-vp--set').forEach((p) => update(p));
    init();
    document.addEventListener('change', (e) => {
      const picker = e.target.closest && e.target.closest('.kis-vp--set');
      if (picker) update(picker);
    });
    subscribeVariantChange(() => window.setTimeout(init, 0));
  });
})();


/* Koopknop: label-animatie (zoals Histrips) en 'Vergelijkbaar' (zoals INHAND). Los van de rest, eigen scope. */
(function () {
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Dawn zet bij een maatwissel de knoptekst via textContent op de eerste <span>; daarna bouwen we de twee lagen opnieuw op.
  function buildTrack(btn) {
    const span = btn.querySelector(':scope > span');
    if (!span || span.querySelector('.kis-buy__inner')) return;
    const t = span.textContent.trim();
    if (!t) return;
    span.innerHTML = `<span class="kis-buy__track"><span class="kis-buy__inner">${esc(t)}</span><span class="kis-buy__inner kis-buy__inner--in" aria-hidden="true">${esc(t)}</span></span>`;
  }
  function initTracks() {
    document.querySelectorAll('.kis-buy').forEach((wrap) => {
      if (wrap._kisTrack) return; wrap._kisTrack = true;
      const run = () => wrap.querySelectorAll('.product-form__submit').forEach(buildTrack);
      run();
      new MutationObserver(run).observe(wrap, { childList: true, subtree: true, characterData: true });
    });
  }
  const imgUrl = (src, w) => { if (!src) return ''; const u = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
  const KIDS = /\b(kids?|junior|jr)\b/i;
  const NOISE = /\b(veters|laces|sokken|socks|cleaner|cleaning|spray|foam|hielpads?|heelpads?)\b/i;
  // Soort uit de titel (Luc 20 okt): hoodies bij hoodies, sets bij sets, onderbroeken bij onderbroeken; schoenen alleen bij schoenen
  const CATS = [['hoodie', /\bhoodies?\b/i], ['broek', /\b(broek(en)?|sweatpants?|pants|joggers?|trackpants?|trainingsbroek)\b/i], ['set', /\bsets?\b/i], ['tshirt', /\b(t-?shirts?|tees?)\b/i], ['short', /\bshorts?\b/i], ['boxer', /\b(boxers?|briefs?|onderbroek(en)?)\b/i], ['sokken', /\b(sokken|socks?)\b/i], ['jas', /\b(jackets?|jas|coat|puffer|vest)\b/i], ['sweater', /\b(crewnecks?|sweaters?|sweatshirts?)\b/i], ['pet', /\b(caps?|pet|beanie|muts)\b/i]];
  const catOf = (t) => { for (const [k, re] of CATS) if (re.test(t || '')) return k; return ''; };
  const groupOf = (type) => (/schoen|sneaker|shoe/i.test(type || '') ? 'shoes' : 'other');
  async function initSiblings() {
    const box = document.querySelector('[data-kis-siblings]');
    if (!box || box._kis) return; box._kis = true;
    const handle = box.dataset.handle; const kids = box.dataset.kids === 'true'; const limit = parseInt(box.dataset.limit, 10) || 7;
    const title = box.dataset.title || ''; const cat = catOf(title); const grp = groupOf(box.dataset.type);
    let q = box.dataset.kisSiblings;
    if (cat) { const m = title.match(CATS.find((c) => c[0] === cat)[1]); if (m && !q.toLowerCase().includes(m[0].toLowerCase())) q += ' ' + m[0]; }
    const root = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    try {
      const r = await fetch(`${root}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type`, { headers: { Accept: 'application/json' } });
      const j = await r.json(); const hits = (((j.resources || {}).results) || {}).products || [];
      const hideSoldout = box.dataset.hideSoldout === 'true';
      const others = hits.filter((h) => h.url && !h.url.split('?')[0].endsWith('/' + handle)).filter((h) => KIDS.test(h.title) === kids).filter((h) => groupOf(h.type) === grp).filter((h) => (cat ? catOf(h.title) === cat : !NOISE.test(h.title))).filter((h) => !hideSoldout || h.available !== false).slice(0, limit);
      if (!others.length) return;
      const row = box.querySelector('[data-kis-siblings-row]');
      row.insertAdjacentHTML('beforeend', others.map((h) => { const img = (h.featured_image && h.featured_image.url) || h.image || ''; return `<a class="kis-sib__item" href="${esc(h.url)}" title="${esc(h.title)}" aria-label="${esc(h.title)}">${img ? `<img src="${esc(imgUrl(img, 160))}" alt="" width="64" height="64" loading="lazy">` : ''}</a>`; }).join(''));
      box.hidden = false;
    } catch (e) { /* stil */ }
  }
  const boot = () => { initTracks(); initSiblings(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
